const initialState = {
  eventList: [],
  businessConfig: {},
  eventsCount: {},
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'EVENT_LIST:DATA:SET':
    return {
      ...state,
      eventList: data,
    };
  case 'EVENT_LIST:BUSINESS_CONFIG:SET':
    return {
      ...state,
      businessConfig: data,
    };
  case 'EVENT_LIST:EVENTS_COUNT:SET':
    return {
      ...state,
      eventsCount: data,
    };
  default:
    return state;
  }
}